import type { Action, Reducer } from "redux";
import { combineReducers } from "redux";

import {
  cartMiniSlice,
  cartSlice,
  checkoutV2Slice,
  freeTrialCartSlice,
  LEGACY__checkoutSlice,
  LEGACY__orderSlice,
  loyaltyApiSlice,
  loyaltyCoreSlice,
  loyaltySlice,
  magentoApiSlice,
  onePageCheckoutFormSlice,
  paymentApiSlice,
  platformApiSlice,
  profileApiSlice,
  standardCheckoutFormSlice,
  subscriptionApiSlice,
} from "./slices";

const reducerMap = {
  cart: cartSlice.reducer,
  freeTrialCart: freeTrialCartSlice.reducer,
  checkout: LEGACY__checkoutSlice.reducer,
  standardCheckoutForm: standardCheckoutFormSlice.reducer,
  onePageCheckoutForm: onePageCheckoutFormSlice.reducer,
  order: LEGACY__orderSlice.reducer,
  cartMini: cartMiniSlice.reducer,
  loyalty: loyaltySlice.reducer,
  loyaltyCore: loyaltyCoreSlice.reducer,
  checkoutV2: checkoutV2Slice.reducer,
  [magentoApiSlice.reducerPath]: magentoApiSlice.reducer,
  [loyaltyApiSlice.reducerPath]: loyaltyApiSlice.reducer,
  [subscriptionApiSlice.reducerPath]: subscriptionApiSlice.reducer,
  [profileApiSlice.reducerPath]: profileApiSlice.reducer,
  [paymentApiSlice.reducerPath]: paymentApiSlice.reducer,
  [platformApiSlice.reducerPath]: platformApiSlice.reducer,
};

export type RootState = {
  [K in keyof typeof reducerMap]: ReturnType<(typeof reducerMap)[K]>;
};

export const rootReducer: Reducer<RootState, Action, Partial<RootState>> = combineReducers(reducerMap);
